<template>
  <div v-if="hasAccess" class="level__resume">
    <template v-if="isLoading">
      <ActionLoader
        loaderClass="level__loading-spinner"
        name="ball-clip-rotate"
      />
    </template>
    <template v-else>
      <button
        v-if="isContentActive"
        v-on="$listeners"
        class="btn btn--secondary level__btn-sub"
        id="stop"
      >
        Close
      </button>
      <button
        v-else
        v-on="$listeners"
        class="btn btn--secondary level__btn-sub"
        id="state-control"
      >
        {{ buttonText }}
      </button>
    </template>
  </div>
  <div v-else class="level__resume">
    <button
      v-if="canUpgradePlan && parentStatus !== 'coming soon'"
      @click="handlePlanUpgrade"
      class="btn btn--secondary level__btn-unsub"
      id="premium-upgrade"
    >
      <LockIcon />
      Get access
    </button>
    <a
      v-else
      class="btn btn--secondary level__btn-unsub"
      :href="`//${plansLink}`"
      id="ine-link"
    >
      <LockIcon />
      {{ parentStatus === 'coming soon' ? 'Coming soon' : 'Get access' }}
    </a>
    <UpgradePlanModal
      v-if="isPremiumUpgradeModalShown"
      :isPremiumOnlyModal="true"
      @toggle-upgrade-modal="isPremiumUpgradeModalShown = false"
      :subscriptionId="planToBeUpgraded.id"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UpgradePlanModal from '@/components/modals/UpgradePlanModal.vue'
import LockIcon from '@/assets/icons/fill/lock.svg'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import CONSTANTS from '@/constants'

export default {
  name: 'LevelControl',
  components: {
    UpgradePlanModal,
    LockIcon: { ...LockIcon, name: 'LockIcon' },
    ActionLoader,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    isContentActive: {
      type: Boolean,
      required: true,
    },
    statusText: {
      type: String,
      required: false,
    },
    hasAccess: {
      type: Boolean,
      required: true,
    },
    status: {
      type: String,
      required: false,
      default: CONSTANTS.CONTENT_USER_STATUS.UNSTARTED,
    },
    plansLink: {
      type: String,
      required: true,
    },
    parentStatus: {
      type: String,
      required: true,
    },
    contentType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      planToBeUpgraded: {},
      isPremiumUpgradeModalShown: false,
    }
  },
  computed: {
    ...mapGetters({
      usersSubscriptions: 'subscriptions/usersSubscriptions',
    }),
    canUpgradePlan() {
      const {
        usersSubscriptions: { personalPlans },
      } = this
      return !!(personalPlans && personalPlans.length)
    },
    buttonText() {
      if (this.statusText) {
        return this.statusText
      }
      if (this.status === CONSTANTS.CONTENT_USER_STATUS.STARTED) {
        return `Resume ${this.contentType}`
      }
      if (this.status === CONSTANTS.CONTENT_USER_STATUS.FINISHED) {
        return `Retake ${this.contentType}`
      }
      return `Start ${this.contentType}`
    },
  },
  methods: {
    handlePlanUpgrade() {
      const {
        usersSubscriptions: { personalPlans },
      } = this
      this.planToBeUpgraded = personalPlans[0]
      this.isPremiumUpgradeModalShown = true
    },
  },
}
</script>
<style lang="scss" scoped>
.level {
  &__btn-sub {
    max-width: 120px;
    @include mobile {
      min-width: 151px;
      max-width: unset;
    }
  }
  &__btn-unsub {
    min-width: 182px;
  }
}
</style>
